import React from "react";
import {
    Content,
    ContentVariants
} from "@patternfly/react-core";
import { getMediaUrl } from "../../../utils/media";

export const DevAttachmentCell = ({ row, props, context }) => {
  const attachmentUrl = row?.raw?.attachment_url;
  const attachmentName = row?.raw?.attachment_name;


  const attachmentUrlExists = Boolean(attachmentUrl);
  const isPublic = row.raw?.visibility === "public";
  const isAuthVisible = 
    (row.raw?.visibility === "authenticated" && context.state.isAuthUser) || 
    (row.raw?.visibility === "restricted" && context.state.userProfile.is_superuser);

  // clickable tylko gdy URL istnieje i użytkownik ma dostęp
  const clickable = attachmentUrlExists && (isPublic || isAuthVisible);
  const cursorStyle = clickable ? "pointer" : "default";
  const colorStyle = clickable ? undefined : "gray";

  const regex = /\/sheets\/.*\/attachment/;
  const downloadUrl = attachmentUrl
    ? regex.test(attachmentUrl) // jeśli nowa struktura
      ? `${props.state.api_url}${attachmentUrl}`  // nowy URL
      : `${props.state.api_url}/${props.state.django_media_dir}/${attachmentUrl}` // stara struktura
    : null;

  const handleDownload = () => {
    if (!attachmentUrl) return;
    getMediaUrl(
      downloadUrl,
      attachmentName
    );
  };
  
  const extension = (() => {
    // najpierw attachmentUrl, jeśli brak → attachmentName
    const firstCheck = attachmentUrl || attachmentName;
    if (!firstCheck) return 'attachment';

    const getLastExtension = (name) => {
      const cleanName = name.split('?')[0];
      const lastSegment = cleanName.split('/').pop();
      const lastDotIndex = lastSegment.lastIndexOf('.');
      return lastDotIndex !== -1 ? lastSegment.slice(lastDotIndex + 1).toLowerCase() : null;
    };

    // spróbuj pobrać rozszerzenie z attachmentUrl
    let ext = getLastExtension(attachmentUrl || '');
    if (ext) return ext;

    // jeśli brak → spróbuj z attachmentName
    ext = getLastExtension(attachmentName || '');
    if (ext) return ext;

    // brak w obu → domyślnie
    return 'attachment';
  })();
  return (
    <>
      {attachmentUrl && attachmentUrl !== '' &&
        <Content
          component={ContentVariants.a}
          target="_blank"
          style={{
            color: colorStyle,
            cursor: cursorStyle 
          }}
          onClick={clickable ? handleDownload: undefined}
        >
          [{extension}]
        </Content>
      }
    </>
  );
};